import { getPhysicalRing } from 'owa-metatags';

const WHITELISTED_PHYSICAL_RINGS = new Set(['Dogfood', 'MSIT', 'WW', 'SDFV2', 'SIP']);

/**
 * Method to limit feature for Dogfood, MSIT and WW
 */
export const isNonPrivateCloud = () => WHITELISTED_PHYSICAL_RINGS.has(getPhysicalRing());
